import { QuickFilterKey, QuickFilterConfig } from "../../types/home";

// ============================================
// QUICK FILTERS — Refined
// ============================================
// Capsule-style pills. Active state uses subtle slate fill
// + weight change instead of teal background. Less visual
// noise, more intentional.

export interface QuickFiltersProps {
  filters: QuickFilterConfig[];
  activeFilter: QuickFilterKey;
  onFilterChange: (filter: QuickFilterKey) => void;
}

export function QuickFilters({
  filters,
  activeFilter,
  onFilterChange,
}: QuickFiltersProps) {
  return (
    <div className="flex items-center gap-1 flex-wrap">
      {filters.map((filter) => {
        const isActive = activeFilter === filter.key;
        return (
          <button
            key={filter.key}
            onClick={() => onFilterChange(filter.key)}
            className={`px-3 py-1 text-xs rounded-full transition-all ${
              isActive
                ? "bg-slate-100 text-slate-900 font-semibold"
                : "bg-transparent text-slate-400 font-medium hover:text-slate-600 hover:bg-slate-50"
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
